"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommentsCountFieldValueGetter = void 0;
const safe_field_value_1 = require("../../safe-field-value");
const get_value_1 = require("./get-value");
const number_1 = require("../../type-checking/number");
class CommentsCountFieldValueGetter extends safe_field_value_1.BaseFieldValueGetter {
    constructor() {
        super(...arguments);
        this.isValidFieldValue = (fieldValue) => {
            return (0, number_1.isNotNegativeNumberValue)(fieldValue);
        };
        this.getEmptyValue = () => (0, get_value_1.getCommentsCountEmptyValue)();
    }
}
exports.CommentsCountFieldValueGetter = CommentsCountFieldValueGetter;
